export const serversList = ['AOC Insurance Broker', 'BOUBYANTAKAFUL'];
export const serverURL = process.env.REACT_APP_ENV == "dev" ? "http://127.0.0.1:4000" : 'https://admin.thinkinsurcare.com:4000';
// export const serverURL = "https://admin.thinkinsurtech.com:8000"
